import { AssetType, SourceType } from "@nendaTypes/cms/CmsAssetType";

export interface CmsAssetsQuery {
  page: number;
  pageSize: number;
  assetId?: string;
  originalTitle?: string;
  title?: string;
  titleLang?: string;
  type?: AssetType[];
  sourceType?: SourceType[];
}

export const buildCmsAssetsQuery = ({
  page,
  pageSize,
  assetId,
  originalTitle,
  title,
  titleLang,
  type = [],
  sourceType = [],
}: CmsAssetsQuery): string => {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  if (assetId) params.set("assetId", assetId);
  if (originalTitle) params.set("originalTitle", originalTitle);
  if (title && titleLang) {
    params.set("title", title);
    params.set("titleLang", titleLang);
  }
  type.forEach((t) => params.append("type", t));
  sourceType.forEach((s) => params.append("sourceType", s));
  return params.toString();
};
